var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"digital-timer"},[_c('digital-interface',{attrs:{"leftNumber":_vm.numminutes,"rightNumber":_vm.numseconds}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }